import FormCooperatorsPage from '@/views/forms/FormCooperatorsPage'
import FormLayout from '@/views/layouts/FormLayout'

export default function Cooperators() {
  return (
    <FormLayout>
      <FormCooperatorsPage />
    </FormLayout>
  )
}
